import sendRequest from '../helpers/axios-setup';

export const getActiveSessions = () =>
  sendRequest.get('/sessions/active').then((r) => r.data).catch((e) => { throw e.response?.data || e; });

export const terminateSession = (sessionId) =>
  sendRequest.patch(`/sessions/${sessionId}/terminate`).then((r) => r.data).catch((e) => { throw e.response?.data || e; });

export const getLoginHistory = (params = {}) =>
  sendRequest.get('/sessions/history', { params }).then((r) => r.data).catch((e) => { throw e.response?.data || e; });
